import RequestStatus from "src/model/RequestStatus";

export interface FutureFeeConfigEntry {
    readonly timestamp: number;
    readonly displayTimestamp: number;
    readonly login?: string;
}

export interface FutureFeeConfig {
    readonly futureFeeConfigMap: Map<string, Map<string, Array<number>>>;// marketplace -> feeType -> date
    readonly futureFeeConfigMapV2?: Map<string, Map<string, Array<FutureFeeConfigEntry>>>;// marketplace -> feeType -> entries
}

export interface GetFutureFeeConfigResponse {
    readonly requestStatus: RequestStatus;
    readonly futureFeeConfig: FutureFeeConfig | null;
}

export interface SaveFutureFeeConfigResponse {
    readonly requestStatus: RequestStatus;
}

export interface DeleteFutureFeeConfigResponse {
    readonly requestStatus: RequestStatus;
}

export enum FeeType {
    FULFILLMENT_FEE = "FulfillmentFee",
    REFERRAL_FEE = "ReferralFee",
    STORAGE_FEE = "FBAStorageFee",
    FBA_INBOUND_CONVENIENCE_FEE = "FBAInboundConvenienceFee",
    LONG_TERM_STORAGE_FEE = "LongTermStorageFee",
    FBA_CUSTOMER_RETURN_PER_UNIT_FEE = "FbaCustomerReturnPerUnitFee",
    CUSTOMER_RETURN_HRR_UNIT_FEE = "CustomerReturnHRRUnitFee",
    DEAL_PARTICIPATION_FEE = "DealParticipationFee",
    DEAL_PERFORMANCE_FEE = "DealPerformanceFee",
    COUPON_PARTICIPATION_FEE = "CouponParticipationFee",
    COUPON_PERFORMANCE_FEE = "CouponPerformanceFee",
    BXGY_PARTICIPATION_FEE = "BxGyParticipationFee",
    BXGY_PERFORMANCE_FEE = "BxGyPerformanceFee",
    PRICE_DISCOUNT_PARTICIPATION_FEE = "PriceDiscountParticipationFee",
    PRICE_DISCOUNT_PERFORMANCE_FEE = "PriceDiscountPerformanceFee",
    AMAZON_UPSTREAM_INBOUND_PROCESSING_FEE = "AmazonUpstreamInboundProcessingFee",
    AMAZON_UPSTREAM_OUTBOUND_PROCESSING_FEE = "AmazonUpstreamOutboundProcessingFee",
    AMAZON_UPSTREAM_STORAGE_TRANSPORTATION_FEE = "AmazonUpstreamStorageTransportationFee",
    STAR_STORAGE_FEE = "STARStorageFee",
    REMOVAL_FEE = "FBARemovalFee",
    DISPOSAL_FEE = "FBADisposalFee",
    LOW_INVENTORY_LEVEL_FEE = "LowInventoryLevelFee",
    PAN_EU_OVERSIZE_FEE = "PanEUOversizeFee",
    FUEL_SURCHARGE = "FuelSurcharge"
}

export default GetFutureFeeConfigResponse
